import React from 'react';
import { Radio, GroupLabel } from '../FormControls';
import { NAME_FORMAT_OPTIONS, NAME_ROLES } from '../../domain/studio';
import { coreSync } from '../../lib/core';
import { SETTINGS_WORDING as W, NAME_ROLE_LABELS } from '../../domain/studioSettings';
import s from './settings.module.css';

// Business Settings → General → Naming Format.
//
// On the tabbed panel, not in the Edit Studio Profile drawer, as MMS puts it:
// the drawer is who the studio is, this is how the app writes things down.
//
// Three radio groups, each offering the same three choices. MMS's defaults are
// Teacher "First Last" and Student and Parent "Last, First", the defaults in
// domain/studio.js.
//
// Saved on change, like every surface in Business Settings (SettingsPage.jsx):
// one merging set naming this panel's own group (#337, data/useSettings.jsx).
//
// The patch names only the role that changed: `nameFormats` is a merged group,
// so `{ ...nameFormats, [role]: id }` would carry this render's copy of the
// other two roles, and two changes faster than a snapshot round-trip would
// spring the first back.

// The three headings are `NAME_ROLE_LABELS` in src/domain/studioSettings.js.

// The live sample under each radio, because "Last First" and "Last, First"
// differ by one character, through the rule the app renders with
// (`core/src/names.rs`, #214), so the example cannot drift from what the
// lists show.
const sampleFor = (format) => coreSync().formatPersonName('Ava', 'Nguyen', format);

export default function NamingFormatPanel({ nameFormats, onChange }) {
  return (
    <div className={s.panel}>
      <div className={s.panelTitle}>{W.namingFormat}</div>

      {NAME_ROLES.map((role) => (
        <div className={s.group} key={role}>
          <GroupLabel>{NAME_ROLE_LABELS[role]}</GroupLabel>
          {NAME_FORMAT_OPTIONS.map((option) => (
            <Radio
              key={option.id}
              name={`name-format-${role}`}
              checked={nameFormats[role] === option.id}
              onChange={() => onChange({ [role]: option.id })}
              label={option.label}
              help={sampleFor(option.id)}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
